module.exports = __webpack_public_path__ + "res/Roboto-BoldCondensed-webfont.eot?127df9aa10d29f902fcc27af27f5b5a3";


//////////////////
// WEBPACK FOOTER
// ./assets/fonts/roboto/Roboto-BoldCondensed-webfont.eot
// module id = 46
// module chunks = 0